import {
  YaMap
} from './map';

export class LazyMap {
  constructor(cls) {
    this._elem = document.querySelector(cls);
    this._map = null;

    this.windowScrollHandler = this.windowScrollHandler.bind(this);
    this.loadMap = this.loadMap.bind(this);

    this.init();
  }

  getMap() {
    return this._map;
  }

  init() {
    if (this._elem === null) {
      return;
    }
    window.addEventListener('scroll', this.windowScrollHandler);

    this.windowScrollHandler();
  }

  windowScrollHandler() {
    if (document.documentElement.clientHeight >= this._elem.getBoundingClientRect().top) {
      this.removeScrollHandler();
      this.loadMap();
    }
  }

  removeScrollHandler() {
    window.removeEventListener('scroll', this.windowScrollHandler);
  }

  loadMap() {
    const self = this;

    return new Promise((resolve) => {
      ymaps.ready(function () {
        new YaMap('.lazymap').init()
          .then((map) => {
            self._map = map;
            resolve(map);
          });
      });
    });
  }
}
